module.exports = __webpack_public_path__ + "img/icon_negociation.3ca1781e.svg";